import { useVehiclePhotosByKind } from 'Components/Gallery';
import { SpecSection } from 'Components/SpecSection/SpecSection';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { DamageCard } from '../ConditionAndDamageSection/Components/DamageCard';
import { getDistinctPanelCount } from '../ConditionAndDamageSection/Components/MobilizeExteriorDamage/MobilizeExteriorDamage';
import { VehicleDetailsExteriorNumericGrading } from '../ConditionAndDamageSection/Components/VehicleDetailsExteriorGrading/VehicleDetailsExteriorNumericGrading';
import { mobilizeConditionFields } from '../ConditionAndDamageSection/ConditionAndDamageSection.consts';
import type { ConditionAndDamageFieldValues } from '../ConditionAndDamageSection/ConditionAndDamageSection.types';

import { useBodyPanelOverlays } from './useBodyPanelOverlays';

import styles from './MobilizeExteriorDamageSection.module.scss';

export const MobilizeExteriorDamageSection: React.FC = () => {
	const { conditionAndDamage, gallery, id, mainInfo, ratings } = useVehicleData();
	const images = useVehiclePhotosByKind(['damage_exterior']);
	const sideLookup = useBodyPanelOverlays(gallery.bodyType);

	const fieldData: ConditionAndDamageFieldValues = {
		...conditionAndDamage,
		grade: ratings.grade,
		id,
		make: mainInfo.make,
		model: mainInfo.model,
		numericGrade: ratings.numericGrade,
	};

	const panelCount = getDistinctPanelCount(images);

	const getOverlayUrl = (image: (typeof images)[0]): string | undefined => {
		const meta = 'damageMeta' in image ? image.damageMeta : null;
		const side = meta?.side;
		if (!side) return undefined;
		return sideLookup[side];
	};

	return (
		<>
			{images.length > 0 ? (
				<div data-testid="mobilize-exterior-damage-section">
					<div className={styles.field}>
						<div className={styles.label}>Exterior grade</div>
						<div className={styles.value}>
							{ratings.numericGrade ? (
								<VehicleDetailsExteriorNumericGrading numericGrade={ratings.numericGrade} />
							) : (
								'-'
							)}
						</div>
					</div>
					<div className={styles.field}>
						<div className={styles.label}>Panels damaged</div>
						<div className={styles.value}>{panelCount}</div>
					</div>
					<div className={styles.grid}>
						{images.map((image) => (
							<DamageCard
								key={image.id}
								showOverlay
								bodyType={gallery.bodyType}
								image={image}
								overlayUrl={getOverlayUrl(image)}
							/>
						))}
					</div>
				</div>
			) : (
				<p>No exterior damage reported</p>
			)}
			<SpecSection data={fieldData} fields={mobilizeConditionFields} />
		</>
	);
};
